var borders_default = {
  "borderT": "_2tSI0",
  "borderB": "nt0Gy",
  "borderL": "pdHwV",
  "borderR": "uH2HW",
  "borderColorOverride": "TH74v"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
